<div class="footer-container">
    <div>For Financial Professional Use Only. This information is current as of {{ currentTimestamp }} EST
        and is
        subject to
        change without notice. The values and information provided are solely for comparative purposes and are NOT a
        replacement for the
        information and illustrations provided by the annuity provider. This information is not intended as, and does
        not constitute, investment
        advice.</div>
    <div class="mt-2">Copyright© 2025 Beacon Annuity Solutions, LLC All Rights Reserved.</div>
</div>